import { createAction, props } from "@ngrx/store";
import {
  IAcuerdo,
  INuevoAcuerdoMrb,
  IRAplazarTema,
  IRAplazarTemaNotificacion,
  IRNAcuerdo,
  IRNAcuerdoNotificacion,
  IRNAcuerdoNotiNuevoTema,
} from "../../interfaces/acuerdos";
import { IAnio, IMes, IMoverAcuerdo } from "../../interfaces/acuerdo";
import {
  IQuitarTema,
  ITemaEliminado,
  ITemaMrbEliminado,
} from "../../interfaces/despacho";

export const cargaAcuerdos = createAction(
  "[Acuerdos Component] carga Acuerdos"
);

export const cargaAcuerdosByTipoAcuerdo = createAction(
  "[Acuerdos Component] cargaAcuerdos By TipoAcuerdo",
  props<{
    tipoAcuerdo: number;
  }>()
);

export const cargaAcuerdosSuccess = createAction(
  "[Acuerdos Component] cargaAcuerdos Success",
  props<{
    acuerdos: IAcuerdo[];
    acuerdoActual: IAcuerdo[];
    historico: IAcuerdo[];
    tipoAcuerdo: number;
  }>()
);

export const cargaAcuerdosFail = createAction(
  "[Acuerdos Component] cargaAcuerdos Fail"
);

// export const updateFechaAcuerdo = createAction(
//   "[Acuerdos Component] update Fecha Acuerdo",
//   props<{ fecha: string; acuerdo: IAcuerdo }>()
// );
export const updateTipoAcuerdo = createAction(
  "[Acuerdos Component] update tipo Acuerdo",
  props<{ tipoAcuerdo: number }>()
);
export const expandAcuerdo = createAction(
  "[Acuerdos Component] expand Acuerdo",
  props<{ idAcuerdo: string }>()
);

export const cargaHistorico = createAction(
  "[Acuerdos Component] cargaHistorico",
  props<{ historico: IAcuerdo[] }>()
);
export const resetAcuerdosByTipo = createAction(
  "[Acuuerdos Component] resetAcuerdos By Tipo",
  props<{ tipoAcuerdo: number }>()
);
export const cargarAcuerdosEditados = createAction(
  "[Acuerdos Component] cargar Acuerdos Editados",
  props<{ acuerdos: IAcuerdo[]; tipoAcuerdo: number }>()
);

export const aplazarTemaMrb = createAction(
  "[Acuerdos Component] aplazarTemaMrb",
  props<{ aplazar: IRAplazarTema; notificacion: IRAplazarTemaNotificacion }>()
);

export const moverTemaMrb = createAction(
  "[Acuerdos Component] moverTemaMrb",
  props<{ payload: IMoverAcuerdo }>()
);

export const aplazarMoverQuitarTemaSuccess = createAction(
  "[Acuerdos Component] aplazar Mover Quitar Tema Success"
);

export const aplazarMoverQuitarTemaFail = createAction(
  "[Acuerdos Component] aplazar Mover Quitar Tema Fail"
);

export const nuevoAcuerdoMRB = createAction(
  "[Acuerdos Component] nuevoAcuerdoMRB"
);

export const cancelarAcuerdoMRB = createAction(
  "[Acuerdos Component] cancelar AcuerdoMRB"
);
export const guardarNuevoAcuerdoMRB = createAction(
  "[Acuerdos Component] guardarNuevoAcuerdoMRB",
  props<{
    acuerdo: IRNAcuerdo;
    notiAcuerdo: IRNAcuerdoNotificacion;
    notiNuevoTema: IRNAcuerdoNotiNuevoTema;
  }>()
);
export const guardarNuevoAcuerdoMRBError = createAction(
  "[Acuerdos Component] guardarNuevoAcuerdoMRBError"
);
export const guardarNuevoAcuerdoMRSuccess = createAction(
  "[Acuerdos Component] guardarNuevoAcuerdoMRSuccess"
);
export const enviarNotificacionNuevoAcuerdoMR = createAction(
  "[Acuerdos Component] enviarNotificacionNuevoAcuerdoMR",
  props<{
    notiAcuerdo: IRNAcuerdoNotificacion;
    notiNuevoTema: IRNAcuerdoNotiNuevoTema;
  }>()
);

export const loadResponsables = createAction(
  "[Acuerdos Component] loadResponsables"
);
export const loadResponsablesFail = createAction(
  "[Acuerdos Component] loadResponsablesFail"
);

export const loadResponsablesSuccess = createAction(
  "[Acuerdos Component] loadResponsablesSuccess",
  props<{ nuevoAcuerdo: INuevoAcuerdoMrb }>()
);

export const nuevoAcuerdoSuccess = createAction(
  "[Acuerdos Component] nuevoAcuerdoSuccess"
);
export const quitarTemaNotificarAcuerdo = createAction(
  "[Acuerdos Component]] quitarTemaNotificarAcuerdo",
  props<{ quitarTema: IQuitarTema; temaEliminado: ITemaMrbEliminado }>()
);

export const resetAcuerdos = createAction("[Acuerdos Component] resetAcuedos");
